import React from "react";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";

export const withNumberFormat = opts => {
  const Formatter = ({ inputRef, onChange, onBlur, name, ...props }) => {
    return (
      <NumberFormat
        {...props}
        {...opts}
        onBlur={() => {
          onBlur({
            target: {
              name
            }
          });
        }}
        getInputRef={inputRef}
        onValueChange={values => {
          if (props.value !== values.value) {
            onChange({
              target: {
                name,
                value: values.value
              }
            });
          }
        }}
      />
    );
  };

  return props => (
    <TextField
      {...props}
      InputProps={{
        inputComponent: Formatter
      }}
    />
  );
};

export default withNumberFormat;
